import { QueryClient, onlineManager } from '@tanstack/react-query';
import { isOnline, onStatusChange } from '../services/networkService';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes — show cached data, refetch in background
      gcTime: 24 * 60 * 60 * 1000, // 24 hours — match persistence maxAge
      retry: 1,
      retryDelay: (attempt) => 1000 * Math.pow(2, attempt),
      refetchOnWindowFocus: false, // App runs on tablets — tab focus events are noisy
      refetchOnReconnect: 'always', // Refetch all visible queries when back online
    },
    mutations: {
      gcTime: 24 * 60 * 60 * 1000, // 24 hours — keep offline mutations alive
      retry: 0, // Don't auto-retry mutations (approval workflows need manual control)
    },
  },
});

// Wire TanStack Query's online manager into our existing networkService.
// This makes queries pause when offline and resume when online.
onlineManager.setEventListener((setOnline) => {
  setOnline(isOnline());
  return onStatusChange(() => {
    setOnline(isOnline());
  });
});
